export default __webpack_public_path__ + "static/media/colors.a42e4686.png";